import React from 'react';
import styled from 'styled-components';
import { useWorkspace } from '~/contexts';
import { colors } from '~/styles';

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 2rem;
    text-align: center;
  `,

  Heading: styled.h2`
    font-size: 1.5rem;
    font-weight: 700;
    color: ${colors.black};
    margin-bottom: 0.5rem;
    line-height: 1.3;
  `,

  Subtext: styled.p`
    font-size: 0.875rem;
    color: ${colors.grey40};
  `,
};

function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Morning';
  if (hour < 17) return 'Afternoon';
  return 'Evening';
}

export default function WelcomeState() {
  const { workspace } = useWorkspace();
  const firstName = workspace.member.name?.split(' ')[0] || '';

  return (
    <S.Container>
      <S.Heading>
        {getGreeting()}
        {firstName ? `, ${firstName}` : ''}
      </S.Heading>
      <S.Subtext>What's on the agenda today?</S.Subtext>
    </S.Container>
  );
}
